import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {SearchForm} from "../../../Model/Dto/SearchForm";
import {TranslationService} from "../../../Services/translation.service";
import {SearchFormsService} from "../../../Services/SearchForms/searchforms.service";
import {LoginService} from "../../../Services/login.service";
import {DxPopoverComponent} from "devextreme-angular";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'np-search-forms',
  standalone: false,
  templateUrl: './search-forms.component.html',
  styleUrl: './search-forms.component.css'
})
export class SearchFormsComponent {

  @Output() onCancel = new EventEmitter<void>();
  @ViewChild('addSearchFormPopup', {static: false}) popoverInstance: DxPopoverComponent;

  allSearchForms: SearchForm[];
  selectedSearchForm: SearchForm;
  conditionValue: 'und' | 'oder';
  createNewSearchFormPopoverVisible: boolean = false;
  renameSearchFormpopoverVisible: boolean = false;

  constructor(public translate: TranslateService, public searchFormService: SearchFormsService, public loginService: LoginService) {
  }

  async ngOnInit() {

    this.createNewSearchFormPopoverVisible = false;
    this.renameSearchFormpopoverVisible = false;
    var customerId = this.loginService.currentUser.customerId;
    var userId = this.loginService.currentUser.id;
    var allSearchForms = await this.searchFormService.getAllbyUserId(customerId, userId);
    this.allSearchForms = allSearchForms ?? [];
  }

  removeRow(index: number) {
    this.selectedSearchForm.searchOptions.splice(index, 1);
  }

  addNewRow() {

    var currentMaxOrder = this.selectedSearchForm?.searchOptions?.length;

    if (currentMaxOrder == undefined) {
      currentMaxOrder = 0;
    }
    this.selectedSearchForm.searchOptions.push({order: currentMaxOrder})
  }

  deleteSearchForm() {

    this.searchFormService.delete(this.selectedSearchForm, this.loginService.currentUser.customerId);

    var IdToRemove = this.selectedSearchForm.id;
    this.allSearchForms = this.allSearchForms.filter(x => x.id != IdToRemove);
    this.selectedSearchForm = null;
  }

  async copySearchForm() {
    var copiedSearchForm = {...this.selectedSearchForm};
    copiedSearchForm.id = null;
    copiedSearchForm.name = copiedSearchForm.name + " " + this.translate.instant("Kopie");
    this.allSearchForms.push(copiedSearchForm);
    await this.searchFormService.updateOrCreateSearchForm(copiedSearchForm, this.loginService.currentUser.customerId);
  }

  createNewSearchForm(nameInput: string) {

    this.selectedSearchForm.name = nameInput;
    this.selectedSearchForm.searchOptions = this.selectedSearchForm.searchOptions ?? [];
    this.selectedSearchForm.searchOptions.push({order: 0});
    this.selectedSearchForm.filterCondition = this.conditionValue ?? "und";

    this.allSearchForms.push(this.selectedSearchForm);
    this.createNewSearchFormPopoverVisible = false;
  }

  onReorderSearchOptions(event: any) {
    const options = this.selectedSearchForm?.searchOptions;
    if (!options) return;

    const itemData = options.splice(event.fromIndex, 1)[0];
    if (itemData) {
      options.splice(event.toIndex, 0, itemData);
      options.forEach((item, index) => {
        if (item) item.order = index;
      });
    }
  }

  openNewRowPopup() {
    this.createNewSearchFormPopoverVisible = true;
    this.selectedSearchForm = new SearchForm();
    this.selectedSearchForm.userId = this.loginService.currentUser.id;
  }

  openRenameSearchFormPopup() {
    this.renameSearchFormpopoverVisible = true;

  }

  renameSearchForm(nameInput: string) {
    this.selectedSearchForm.name = nameInput;
    this.allSearchForms.find(x => x.id == this.selectedSearchForm.id).name = nameInput;
    this.renameSearchFormpopoverVisible = false;
  }

  saveSearchForm() {

    this.searchFormService.updateOrCreateSearchForm(this.selectedSearchForm, this.loginService.currentUser.customerId);

  }

  popupClose() {
    this.onCancel.emit();
  }

  onPopoverShown() {
    this.popoverInstance.instance.repaint();
  }

  protected readonly name = name;
}
